import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import React from 'react';
import './App.css';
import './styles/OurVision.css';
import './styles/GetInTouch.css';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollRestoration from './components/ScrollRestoration';

import Home from './pages/Home';
import Company from './pages/Company';
import WebDevelopment from './pages/services/WebDevelopment';
import ApplicationDevelopment from './pages/services/ApplicationDevelopment';
import UIUXDesign from './pages/services/UiUxDesign';
import DigitalMarketing from './pages/services/DigitalMarketing';
import DataAnalytics from './pages/services/DataAnalytics';
import CloudSolutions from './pages/services/CloudSolutions';
import Staffing from './pages/Staffing';
import Career from './pages/Career';
import Contactus from './pages/Contactus';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import Technology from './pages/Technology';
import Qr from "./pages/Qr";
import OnboardingForm from './pages/OnboardingForm';
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function Layout() {
  const location = useLocation();

  const hideLayout =
    location.pathname === "/admin/login" ||
    location.pathname === "/dashboard" ||
    location.pathname === "/admin/forgot-password" ||
    location.pathname.startsWith("/admin/reset-password");

  return (
    <div className="App">

      {!hideLayout && <Header />}

      <ScrollRestoration />

      <main className="main-content">
        <Routes>
           <Route path="/" element={<Home />} />
          <Route path="/company" element={<Company />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/application-development" element={<ApplicationDevelopment />} />
          <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/services/data-analytics" element={<DataAnalytics />} />
          <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
          <Route path="/staffing" element={<Staffing />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/qr" element={<Qr />} />
          <Route path="/onboardingForm" element={<OnboardingForm />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password/:token" element={<ResetPassword />} />
        </Routes>
      </main>

      {!hideLayout && <Footer />}

    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;